import { Component, ElementRef, ViewChild } from '@angular/core';
import { WizBasePopUp } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { COMPUTE_MODE, WidgetLine } from '@wizeoo/akm-compute-lib';
import { WizEventManager} from '@wizeoo/akm-component-lib';

import { ALK_EVENT_TYPE, WIDGET_STATE } from '../../../model/enums';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { FormWidget } from '../form/form.widget';
import { IWidget } from '../../../manager/widgets/i-widget';
import { AlkEvent } from '../../../framework/events/alk.event';
import { FastSelectData, getDefaultWidgetConfigurationObj } from './../../../manager/widgets/widget.engine';


// contrat d'interface des params de la popUp
export interface CalendarPopParams {
  widget: IWidget; // calendar source
  startDate: number; // la conf
  widgetLine: WidgetLine; // ligne source
  callBack: Function; // callback
}


@Component({
  // popUp d'ajout d'une entrée de calendrier
  selector: 'calendar-add-pop',
  templateUrl: './calendar-add.pop.html',
})
export class CalendarAddPop extends WizBasePopUp {

  @ViewChild('formWid', { read: FormWidget }) formWid: FormWidget;
  constructor(public elementRef: ElementRef) {
    super();
  }

  public code: string = 'calForm';

  public saveDisabled: boolean = true; // par défaut, on sauvegarde pas. Tous les champs doivent être OK

  protected fei: FeiVO; // les données
  public context: WidgetConfigurationObj = null; // la configuration
  public scenario: string;
  public startDate: number;
  private widgetLine: WidgetLine = null; // la PL en cours d'update

  public show(): void {
    let params: CalendarPopParams = this.datas;
    this.fei = params.widget.fei as FeiVO;
    this.context = params.widget.context;
    this.widgetLine = params.widgetLine;
    this.startDate = params.startDate;
    this.drawContent();

    WizEventManager.addListener(this, this.formWid, ALK_EVENT_TYPE.FORM_SAVED, this.hide);
  }

  /** construction des champs de saisie */
  public drawContent() {
    this.formWid.settings = this.context;
    this.formWid.context = this.context;
    this.formWid.setDatasource(this.fei.vision, this.fei.visionStep, this.fei.scenario, getDefaultWidgetConfigurationObj());
 
    this.formWid.state = WIDGET_STATE.READY;
    
    this.formWid.showSelect = false;
    this.formWid.showAdd = false;
    this.formWid.showDelete = false;
    this.formWid.showRevert = false;
    
    let fsd: FastSelectData = {fei: this.fei, kind: this.datas.widget.widgetGlobalKind, data: this.widgetLine, date: this.startDate};
    let e: AlkEvent = new AlkEvent(ALK_EVENT_TYPE.PIVOT_DOUBLE, fsd);
    this.formWid.injectWidgetLine(e); // injection de la WidgetLine
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide(): void {
    WizEventManager.removeListener(this, this.formWid, ALK_EVENT_TYPE.FORM_SAVED);
  }
}
